// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ae9a6614","239":"2398f2eb","732":"4d74da4c"}[chunkId] + ".chunk.js";
};